export default __webpack_public_path__ + "static/media/hero.93bc24d8.svg";